import { render, staticRenderFns } from "./PriceDetailsPopin.vue?vue&type=template&id=fbc742de"
import script from "./PriceDetailsPopin.vue?vue&type=script&lang=ts"
export * from "./PriceDetailsPopin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports